import React from 'react'
import {  } from "react-google-charts";

const InsightViewStatMultiCol =(props)=>{
    const {viewData, activeOption} = props

    const currentOption = activeOption;// || viewData.DefaultOption;

    //var data = viewData.ViewData[currentOption].ChartData[1];
    
    if(viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].ChartData
     && viewData.ViewData[currentOption].ChartData.length >= 2
    ){
        
        // console.log("layout response view", viewData.ViewData[currentOption]);
    
        return (
            <div className='uiInsightStatData uiPadding10'>
                <div>
                    <span className='uiBold' style={{fontSize: '14px'}}>{viewData.X_AXIS_Title}</span>
                </div>
                {
                    viewData.ViewData[currentOption].ChartData.map((row, index)=>(
                        <div key={index}>
                            <div style={{width: "100px", display:"inline-block"}}>
                                <span className='uiBold' style={{fontSize: '12px'}}>{row[0]}</span> 
                            </div>
                            <div style={{width: "30px", display:"inline-block"}}>
                                <span className='uiBold' style={{fontSize: '12px', color:'#0277BD'}}>{row[1]}</span> 
                            </div>
                            {viewData.X_AXIS_Title !== viewData.ViewData[currentOption].Y_AXIS_Title &&
                                <span className='uiSpacerL20' style={{fontSize: '12px'}}>{viewData.ViewData[currentOption].Y_AXIS_Title}</span>
                            }
                        </div>
                    ))
                }
            </div>
        )

    }

    return null;
}

export default InsightViewStatMultiCol
